// Public course resources may be website-relative or HTTP(S), never executable URLs.
export function courseResourceUrl(value?: string): string | null {
  const url = (value || '').trim();
  if (!url || /[\u0000-\u001f\u007f\\]/.test(url) || url.startsWith('//')) return null;
  try {
    const parsed = new URL(url, 'https://course-resource.local/');
    return ['https:', 'http:'].includes(parsed.protocol) && !parsed.username && !parsed.password ? url : null;
  } catch { return null; }
}
